import { AnyAction } from "redux";
import produce from "immer";
import { initialBom, initialBomState } from "./defaultState";
// import {

//   CLEAR_BOM,
//   CLEAR_BOM_STATE,
//   FETCH_APPROVAL_BOM_LIST_FAILED,
//   FETCH_APPROVAL_BOM_LIST_PROGRESS,
//   FETCH_APPROVAL_BOM_LIST_SUCCESS,
//   FETCH_BOM_FAILED,
//   FETCH_BOM_ITEM_FAILED,
//   FETCH_BOM_ITEM_PROGRESS,
//   FETCH_BOM_ITEM_SUCCESS,
//   FETCH_BOM_LIST_FAILED,
//   FETCH_BOM_LIST_PROGRESS,
//   FETCH_BOM_LIST_SUCCESS,
//   FETCH_BOM_PROGRESS,
//   FETCH_BOM_SUCCESS,
//   FETCH_COMPLETE_BOM_FAILED,
//   FETCH_COMPLETE_BOM_PROGRESS,
//   FETCH_COMPLETE_BOM_SUCCESS,
//   FETCH_ORDER_EXISTING_BOM_FAILED,
//   FETCH_ORDER_EXISTING_BOM_PROGRESS,
//   FETCH_ORDER_EXISTING_BOM_SUCCESS,

// } from "./index";
import { LoadState } from "../../constants/enums";
import { IBomState } from "./bom.types";
import { IStoreState } from "..";
import {
  BomActions,
  FETCH_NEW_BOM_LIST_FAILED,
  FETCH_NEW_BOM_LIST_PROGRESS,
  FETCH_NEW_BOM_LIST_SUCCESS,
} from ".";

// // Local string constants to avoid import cycles with action creators.
const FETCH_BOM_LIST_PROGRESS = "FETCH_BOM_LIST_PROGRESS";
const FETCH_BOM_LIST_SUCCESS = "FETCH_BOM_LIST_SUCCESS";
const FETCH_BOM_LIST_FAILED = "FETCH_BOM_LIST_FAILED";
const FETCH_BOM_PROGRESS = "FETCH_BOM_PROGRESS";
const FETCH_BOM_SUCCESS = "FETCH_BOM_SUCCESS";
const FETCH_BOM_FAILED = "FETCH_BOM_FAILED";
const FETCH_COMPLETE_BOM_PROGRESS = "FETCH_COMPLETE_BOM_PROGRESS";
const FETCH_COMPLETE_BOM_SUCCESS = "FETCH_COMPLETE_BOM_SUCCESS";
const FETCH_COMPLETE_BOM_FAILED = "FETCH_COMPLETE_BOM_FAILED";
const FETCH_APPROVAL_BOM_LIST_PROGRESS = "FETCH_APPROVAL_BOM_LIST_PROGRESS";
const FETCH_APPROVAL_BOM_LIST_SUCCESS = "FETCH_APPROVAL_BOM_LIST_SUCCESS";
const FETCH_APPROVAL_BOM_LIST_FAILED = "FETCH_APPROVAL_BOM_LIST_FAILED";
const FETCH_BOM_ITEM_PROGRESS = "FETCH_BOM_ITEM_PROGRESS";
const FETCH_BOM_ITEM_SUCCESS = "FETCH_BOM_ITEM_SUCCESS";
const FETCH_BOM_ITEM_FAILED = "FETCH_BOM_ITEM_FAILED";
const CLEAR_BOM = "CLEAR_BOM";
const CLEAR_BOM_STATE = "CLEAR_BOM_STATE";
const FETCH_ORDER_EXISTING_BOM_PROGRESS = "FETCH_ORDER_EXISTING_BOM_PROGRESS";
const FETCH_ORDER_EXISTING_BOM_SUCCESS = "FETCH_ORDER_EXISTING_BOM_SUCCESS";
const FETCH_ORDER_EXISTING_BOM_FAILED = "FETCH_ORDER_EXISTING_BOM_FAILED";

export const bomReducer = (
  state: IStoreState["bom"] = initialBomState,
  action: BomActions,
) => {
  switch (action.type) {
    case FETCH_BOM_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.data = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_BOM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_BOM_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case FETCH_NEW_BOM_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.newBom.loading = LoadState.InProgress;
        draftState.newBom.data = [];
        draftState.newBom.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_NEW_BOM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.newBom.loading = LoadState.Loaded;
        draftState.newBom.data = data;
        draftState.newBom.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_NEW_BOM_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.newBom.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_BOM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.bom.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_BOM_SUCCESS: {
      const { data, meta } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bom.loading = LoadState.Loaded;
        draftState.bom.data = data;
        draftState.bom.meta = meta;
      });
      return newState;
    }
    case FETCH_BOM_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bom.loading = LoadState.Failed;
        draftState.bom.error = errorMessage;
      });
      return newState;
    }

    case FETCH_COMPLETE_BOM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.completeBom.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_COMPLETE_BOM_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.completeBom.loading = LoadState.Loaded;
        draftState.completeBom.data = data;
      });
      return newState;
    }
    case FETCH_COMPLETE_BOM_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.completeBom.loading = LoadState.Failed;
        draftState.completeBom.error = errorMessage;
      });
      return newState;
    }

    case FETCH_APPROVAL_BOM_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.approvalBomList.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_APPROVAL_BOM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.approvalBomList.loading = LoadState.Loaded;
        draftState.approvalBomList.data = data;
        draftState.approvalBomList.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_APPROVAL_BOM_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.approvalBomList.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_BOM_ITEM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.bomItem.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_BOM_ITEM_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bomItem.loading = LoadState.Loaded;
        draftState.bomItem.data = data;
      });
      return newState;
    }
    case FETCH_BOM_ITEM_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bomItem.loading = LoadState.Failed;
        draftState.bomItem.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_BOM: {
      const newState = produce(state, (draftState) => {
        draftState.bom.loading = LoadState.NotLoaded;
        draftState.bom.data = initialBom;
        draftState.bom.error = null;
      });
      return newState;
    }

    case CLEAR_BOM_STATE: {
      return initialBomState;
    }

    //
    case FETCH_ORDER_EXISTING_BOM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.order_existing_bom.loading = LoadState.InProgress;
        draftState.order_existing_bom.data = [];
        draftState.order_existing_bom.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_ORDER_EXISTING_BOM_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.order_existing_bom.loading = LoadState.Loaded;
        draftState.order_existing_bom.data = data;
        draftState.order_existing_bom.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ORDER_EXISTING_BOM_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.order_existing_bom.loading = LoadState.Failed;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
